import { SFuncModal, SGeneralForms } from 'shj-components'
import React, { useEffect, useRef, useState } from 'react'
import { Button, Input, Spin } from 'antd'
import { replaceRule, trimStr } from '@/utils/data.ts'
import { getPackModelDetail, getProductEnums, packModelSave } from '@/services/product.ts'
import RulesModal from '@/pages/baseProduct/components/RuleModal/RulesModal.tsx'
import { useSetState } from 'ahooks'
import styles from '@/pages/baseProduct/packageTemplate/addOrEdit/index.module.less'

const StepBaseInfo = props => {
  const { editRef, cacheId, baseInfo, setBaseInfo } = props
  const ref = useRef()
  const [loading, setLoading] = useState(false)
  // 增项范围规则
  const [ruleModal, setRuleModal] = useSetState({
    open: false,
    mode: 'modal',
    value: '',
  })
  // 升降级范围规则
  const [changeLevelScopeRule, setChangeLevelScopeRule] = useSetState({
    open: false,
    mode: 'modal',
    value: '',
  })

  const onFormRef = () => {
    const { onFormRef } = ref.current || {}
    return onFormRef?.()
  }

  useEffect(() => {
    getInfo()
  }, [baseInfo])

  const getInfo = () => {
    console.log(baseInfo)
    if (!cacheId) return
    // setLoading(true)
    // getPackModelDetail({ packId: cacheId })
    //   .then(res => {
    onFormRef()?.setFieldsValue({ ...baseInfo })
    setRuleModal({ value: baseInfo.addRuleJson })
    setChangeLevelScopeRule({ value: baseInfo.changeLevelScope })
    //   })
    //   .finally(() => setLoading(false))
  }

  const onEditRule = type => {
    type === 'addRuleJson' ? setRuleModal({ open: true }) : setChangeLevelScopeRule({ open: true })
  }

  const onFinish = (): Promise<any> => {
    return new Promise((resolve, reject) => {
      onFormRef()
        ?.validateFields()
        .then(values => {
          props.setLoading?.(true)
          console.log(values, '表单数据')
          // setBaseInfo({
          //   ...values,
          //   id: cacheId,
          //   addRuleJson: ruleModal.value,
          //   changeLevelScope: changeLevelScopeRule.value,
          // })
          values = {
            ...values,
            id: cacheId,
            addRuleJson: ruleModal.value,
            changeLevelScope: changeLevelScopeRule.value,
          }
          // packModelSave({ ...values, id: cacheId, addRuleJson: ruleModal.value })
          //   .then(res => {
          resolve(values)
          //   })
          //   .catch(reject)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  const getOption = async () => {
    const packModelTypeList = await getProductEnums('com.shj.saas.plus.product.enums.PackModelType')
    const ChooseTimeTypeList = await getProductEnums(
      'com.shj.saas.plus.product.enums.ChooseTimeType'
    )
    return new Promise(resolve => {
      if (!cacheId) {
        onFormRef()?.setFieldsValue({ packModelType: packModelTypeList[0].key,chooseTimeType: ChooseTimeTypeList[1].key})
      }
      resolve({
        packModelTypeList: packModelTypeList.map(item => {
          return {
            label: item.description,
            value: item.key,
          }
        }),
        ChooseTimeTypeList: ChooseTimeTypeList.map(item => {
          return {
            label: item.description,
            value: item.key,
          }
        }),
      })
    })
  }

  if (editRef) {
    editRef.onFinish = onFinish
    editRef.isSubtract = onFormRef()?.getFieldValue('isSubtract')
  }

  return (
    <Spin spinning={loading}>
      <div className={`${styles.edit_wrap}  ${styles.newFormStyle}`} style={{ width: 460 }}>
        <SGeneralForms
          ref={ref}
          initialValues={{
            isSubtract: true,
            isAdd: true,
            allowUpLevel: true,
            allowDownLevel: true,
            allowRefund: true,
            limitSelectSameCategory: true,
            standardFlag: true,
          }}
          layout={'vertical'}
          httpOptionsFn={getOption}
          configs={[
            {
              formItem: [
                { name: 'id', name: 'id', hidden: true },
                {
                  spanCol: 24,
                  label: '模板类型',
                  name: 'packModelType',
                  type: 'radio',
                  hidden: true,
                  layout: 'vertical',
                  data: 'packModelTypeList',
                  comConfig: {
                    // disabled: !!cacheId,
                  },
                },
                {
                  spanCol: 24,
                  label: '模板名称',
                  name: 'modelName',
                  layout: 'vertical',
                  required: true,
                  rules: [{ required: true, message: '模板名称不能为空' }],
                  comConfig: {
                    showCount: true,
                    maxLength: 30,
                    onChange: e => onFormRef()?.setFieldValue('modelName', e.target.value),
                  },
                },
                {
                  spanCol: 24,
                  label: '备注',
                  name: 'remarks',
                  layout: 'vertical',
                  type: 'textarea',
                  comConfig: { showCount: true, maxLength: 100 },
                },
              ],
            },
            {
              title: '通项选材',
              formItem: [
                {
                  spanCol: 8,
                  label: '通项是否标配',
                  name: 'standardFlag',
                  type: 'switch',
                  comConfig: {
                    checkedChildren: '是',
                    unCheckedChildren: '否',
                  },
                },
                {
                  name: 'chooseTimeType',
                  label: '可选材时间',
                  type: 'radio',
                  spanCol: 16,
                  data: 'ChooseTimeTypeList',
                },
                {
                  spanCol: 8,
                  label: '限制预算量',
                  tooltip:
                    '限制预算量指通项有设置预算量时，通项选材预算量累计不能超过预设预算量（包括升降级数量合计）',
                  name: 'limitQuoteNumFlag',
                  type: 'switch',
                  comConfig: {
                    checkedChildren: '是',
                    unCheckedChildren: '否',
                  },
                },
              ],
            },
            {
              title: '升降级',
              formItem: [
                {
                  spanCol: 8,
                  label: '是否可升级',
                  name: 'allowUpLevel',
                  type: 'switch',
                  comConfig: {
                    checkedChildren: '是',
                    unCheckedChildren: '否',
                  },
                },
                {
                  spanCol: 8,
                  label: '是否可降级',
                  name: 'allowDownLevel',
                  type: 'switch',
                  comConfig: {
                    checkedChildren: '是',
                    unCheckedChildren: '否',
                  },
                },
                {
                  spanCol: 8,
                  label: '是否限制同类',
                  tooltip: '同类指特项代码相同',
                  name: 'limitSelectSameCategory',
                  type: 'switch',
                  isDeps: true,
                  deps: form =>
                    form.getFieldValue('allowDownLevel') || form.getFieldValue('allowUpLevel'),
                  comConfig: {
                    checkedChildren: '是',
                    unCheckedChildren: '否',
                  },
                },
                {
                  spanCol: 24,
                  label: '升降级范围',
                  isDeps: true,
                  deps: form =>
                    form.getFieldValue('allowUpLevel') || form.getFieldValue('allowDownLevel'),
                  children: (
                    <div>
                      <Button onClick={() => onEditRule('changeLevelScopeRule')}>编辑规则</Button>
                      {changeLevelScopeRule?.value && (
                        <Input.TextArea
                          autoSize={{ minRows: 1, maxRows: 4 }}
                          disabled
                          style={{ marginTop: 6 }}
                          value={replaceRule(changeLevelScopeRule.value)}
                        />
                      )}
                    </div>
                  ),
                },
              ],
            },
            {
              title: '增减项',
              formItem: [
                {
                  spanCol: 8,
                  label: <span>是否可减项</span>,
                  tooltip: '指标配的通项和产品',
                  name: 'isSubtract',
                  type: 'switch',
                  comConfig: {
                    checkedChildren: '是',
                    unCheckedChildren: '否',
                  },
                },
                {
                  spanCol: 16,
                  label: '减项个数上限',
                  name: 'subtractNumMax',
                  type: 'inputNumber',
                  isDeps: true,
                  deps: [{ name: 'isSubtract', value: true }],
                  required: true,
                  rules: [{ required: true, message: '减项个数上限不能为空' }],
                  comConfig: { min: 0, max: 99999, precision: 0 },
                },
                {
                  spanCol: 8,
                  label: '是否可增项',
                  name: 'isAdd',
                  type: 'switch',
                  comConfig: {
                    checkedChildren: '是',
                    unCheckedChildren: '否',
                  },
                },
                {
                  spanCol: 24,
                  label: '增项范围',
                  isDeps: true,
                  deps: [{ name: 'isAdd', value: true }],
                  children: (
                    <div>
                      <Button onClick={() => onEditRule('addRuleJson')}>编辑规则</Button>
                      {ruleModal?.value && (
                        <Input.TextArea
                          autoSize={{ minRows: 1, maxRows: 4 }}
                          disabled
                          style={{ marginTop: 6 }}
                          value={replaceRule(ruleModal.value)}
                        />
                      )}
                    </div>
                  ),
                },
              ],
            },
          ]}
        />
        <RulesModal
          modalProps={{ ...ruleModal }}
          type={'productFilterRule'}
          onCancel={() => setRuleModal({ open: false })}
          onOk={(value: string) => setRuleModal({ value })}
        />
        <RulesModal
          modalProps={{ ...changeLevelScopeRule }}
          type={'productFilterRule'}
          onCancel={() => setChangeLevelScopeRule({ open: false })}
          onOk={(value: string) => setChangeLevelScopeRule({ value })}
        />
      </div>
    </Spin>
  )
}

export default StepBaseInfo
